import Index from "./Index.jsx";

const ACTIVITY_LOG = {
  INDEX: Index,
};

export default ACTIVITY_LOG;